export const wfBubble_37 = { 
    current : {
        backgroundColor: '#9302c9',
        borderColor: '#7501A0',
        color: 'white',
        fontWeight: '600',
    },
    visited : {
        backgroundColor: '#E5E5E5',
        borderColor: '#c5c5c5',
        color: '#5b5b5b',
        cursor: 'pointer',
        fontWeight: '600',
    },
    notVisited : {
        backgroundColor: '#E5E5E5',
        borderColor: '#c5c5c5',
        color: '#5b5b5b',
        fontWeight: '600',
    }
}